var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostcard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4018 5.87985H23.4019L23.4018 5.87747C23.3766 5.34903 22.9487 4.91785 22.4398 4.91785H1.55983C1.02821 4.91785 0.597827 5.34824 0.597827 5.87985V18.1439C0.597827 18.6755 1.02821 19.1059 1.55983 19.1059H22.4398C22.9714 19.1059 23.4018 18.6755 23.4018 18.1439V5.87985ZM21.9818 17.6619H2.04183V6.33785H21.9818V17.6619Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 15.7458C12.4114 15.7458 12.7218 15.4355 12.7218 15.0238V9.09585C12.7218 8.7059 12.385 8.39785 11.9998 8.39785C11.6134 8.39785 11.2778 8.70707 11.2778 9.11985V15.0238C11.2778 15.4103 11.587 15.7458 11.9998 15.7458Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39197 13.0097H7.89597C8.28241 13.0097 8.61797 12.7005 8.61797 12.2877C8.61797 11.8761 8.30758 11.5657 7.89597 11.5657H4.39197C4.00553 11.5657 3.66997 11.8749 3.66997 12.2877C3.66997 12.7005 4.00553 13.0097 4.39197 13.0097Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1839 10.1301H19.8959C19.9793 10.1301 20.0526 10.1021 20.1053 10.0495C20.1579 9.99686 20.1859 9.92351 20.1859 9.84015V7.75215C20.1859 7.60784 20.0707 7.46215 19.8959 7.46215H17.1839C17.1005 7.46215 17.0272 7.49015 16.9746 7.54279C16.9219 7.59543 16.8939 7.66878 16.8939 7.75215V9.84015C16.8939 9.92351 16.9219 9.99686 16.9746 10.0495C17.0272 10.1021 17.1005 10.1301 17.1839 10.1301Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39197 15.674H9.09597C9.48241 15.674 9.81797 15.3648 9.81797 14.952C9.81797 14.5392 9.48241 14.23 9.09597 14.23H4.39197C4.00553 14.23 3.66997 14.5392 3.66997 14.952C3.66997 15.3636 3.98036 15.674 4.39197 15.674Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostcard);
export default __webpack_public_path__ + "static/media/postcard.c68cfee1.svg";
export { ForwardRef as ReactComponent };